import { ArticleItem } from '../../types';
import {
  threeMedicalDeviceReviewGuidelinesCn,
  threeMedicalDeviceReviewGuidelinesEn
} from './three-medical-device-review-guidelines';
import {
  entrustedManufacturingFlightInspectionCn,
  entrustedManufacturingFlightInspectionEn
} from './entrusted-manufacturing-flight-inspection';
import {
  medicalDeviceReviewGuidelinePlanCn,
  medicalDeviceReviewGuidelinePlanEn
} from './medical-device-review-guideline-plan';
import {
  tenInnovativeMedicalDevicesCn,
  tenInnovativeMedicalDevicesEn
} from './ten-innovative-medical-devices';
import {
  aprilInnovativeMedicalDevicesCn,
  aprilInnovativeMedicalDevicesEn
} from './april-innovative-medical-devices';
import {
  medicalDeviceVigilancePlanGuideCn,
  medicalDeviceVigilancePlanGuideEn
} from './medical-device-vigilance-plan-guide';
import {
  marchTerminatedRegistrationReviewCn,
  marchTerminatedRegistrationReviewEn
} from './march-terminated-registration-review';
import {
  periodicSafetyUpdateReportGuideCn,
  periodicSafetyUpdateReportGuideEn
} from './periodic-safety-update-report-guide';
import {
  nationalMedicalDeviceInspectionResults2026Cn,
  nationalMedicalDeviceInspectionResults2026En
} from './national-medical-device-inspection-results-2026';
import {
  marchMedicalDeviceReviewDataCn,
  marchMedicalDeviceReviewDataEn
} from './march-medical-device-review-data';

export const ARTICLES_EN: ArticleItem[] = [
  marchMedicalDeviceReviewDataEn,
  nationalMedicalDeviceInspectionResults2026En,
  periodicSafetyUpdateReportGuideEn,
  marchTerminatedRegistrationReviewEn,
  medicalDeviceVigilancePlanGuideEn,
  aprilInnovativeMedicalDevicesEn,
  tenInnovativeMedicalDevicesEn,
  medicalDeviceReviewGuidelinePlanEn,
  entrustedManufacturingFlightInspectionEn,
  threeMedicalDeviceReviewGuidelinesEn
];

export const ARTICLES_CN: ArticleItem[] = [
  marchMedicalDeviceReviewDataCn,
  nationalMedicalDeviceInspectionResults2026Cn,
  periodicSafetyUpdateReportGuideCn,
  marchTerminatedRegistrationReviewCn,
  medicalDeviceVigilancePlanGuideCn,
  aprilInnovativeMedicalDevicesCn,
  tenInnovativeMedicalDevicesCn,
  medicalDeviceReviewGuidelinePlanCn,
  entrustedManufacturingFlightInspectionCn,
  threeMedicalDeviceReviewGuidelinesCn
];
